(function () {
  'use strict';
  var reduced = window.matchMedia('(prefers-reduced-motion: reduce)').matches;
  document.documentElement.classList.add('prrym-ready');

  function initReveal(root) {
    var items = (root || document).querySelectorAll('.prrym-reveal:not(.is-visible)');
    if (!items.length) return;
    if (!('IntersectionObserver' in window) || reduced) { items.forEach(function (el) { el.classList.add('is-visible'); }); return; }
    var io = new IntersectionObserver(function (entries) {
      entries.forEach(function (entry) { if (entry.isIntersecting) { entry.target.classList.add('is-visible'); io.unobserve(entry.target); } });
    }, { rootMargin: '0px 0px -8% 0px', threshold: 0.06 });
    items.forEach(function (el) { io.observe(el); });
  }

  /* 3D tilt for cards and panels (mouse only), with a soft light that follows the cursor */
  function initTilt(root) {
    if (reduced || !window.matchMedia('(hover: hover) and (pointer: fine)').matches) return;
    (root || document).querySelectorAll('.prrym-card, .prrym-cat, .prrym-tile, .prrym-step, .prrym-specs__panel, .product-card, .prrym-gal__media').forEach(function (el) {
      if (el.dataset.prrymTilt) return;
      el.dataset.prrymTilt = '1';
      var max = el.classList.contains('prrym-cat') ? 5 : el.classList.contains('prrym-card') || el.classList.contains('product-card') ? 7 : el.classList.contains('prrym-gal__media') ? 5 : 4;
      var raf = 0;
      el.addEventListener('pointermove', function (e) {
        var r = el.getBoundingClientRect();
        var x = (e.clientX - r.left) / r.width - 0.5;
        var y = (e.clientY - r.top) / r.height - 0.5;
        cancelAnimationFrame(raf);
        raf = requestAnimationFrame(function () {
          el.style.setProperty('--ry', (x * max).toFixed(2) + 'deg');
          el.style.setProperty('--rx', (-y * max).toFixed(2) + 'deg');
          el.style.setProperty('--mx', ((x + 0.5) * 100).toFixed(1) + '%');
          el.style.setProperty('--my', ((y + 0.5) * 100).toFixed(1) + '%');
        });
      });
      el.addEventListener('pointerleave', function () {
        cancelAnimationFrame(raf);
        el.style.setProperty('--rx', '0deg');
        el.style.setProperty('--ry', '0deg');
      });
    });
  }

  /* Subtle scroll parallax for category and showcase visuals */
  var parallaxEls = [];
  var parallaxTicking = false;
  function updateParallax() {
    parallaxTicking = false;
    var vh = window.innerHeight;
    parallaxEls.forEach(function (el) {
      var host = el.parentElement;
      if (!host) return;
      var r = host.getBoundingClientRect();
      if (r.bottom < -100 || r.top > vh + 100) return;
      var p = (r.top + r.height / 2 - vh / 2) / vh;
      el.style.setProperty('--py', (p * -26).toFixed(1) + 'px');
    });
  }
  function initParallax(root) {
    if (reduced) return;
    (root || document).querySelectorAll('.prrym-cat__media img, .prrym-cat__fallback svg, .prrym-shot > img, .prrym-tex svg').forEach(function (el) {
      if (parallaxEls.indexOf(el) === -1) parallaxEls.push(el);
    });
    if (!parallaxEls.length) return;
    if (!initParallax.bound) {
      initParallax.bound = true;
      document.addEventListener('scroll', function () { if (!parallaxTicking) { parallaxTicking = true; requestAnimationFrame(updateParallax); } }, { passive: true, capture: true });
      window.addEventListener('resize', updateParallax, { passive: true });
    }
    updateParallax();
  }

  /* Quick view using the Section Rendering API */
  var lastFocus = null;
  function ensureModelViewer(scope) {
    var mv = scope.querySelector('model-viewer');
    if (!mv) return;
    var fallback = function () {
      if (!window.customElements || customElements.get('model-viewer')) return;
      var s = document.createElement('script');
      s.type = 'module';
      s.src = 'https://cdn.jsdelivr.net/npm/@google/model-viewer@3.5.0/dist/model-viewer.min.js';
      document.head.appendChild(s);
    };
    if (window.Shopify && typeof window.Shopify.loadFeatures === 'function') {
      window.Shopify.loadFeatures([{ name: 'model-viewer-ui', version: '1.0', onLoad: function (err) {
        if (err) { fallback(); return; }
        try { if (window.Shopify.ModelViewerUI) new window.Shopify.ModelViewerUI(mv); } catch (_) {}
        setTimeout(fallback, 1500);
      } }]);
    } else { fallback(); }
  }
  function getDialog() {
    var dlg = document.getElementById('PrrymQuickView');
    if (dlg) return dlg;
    dlg = document.createElement('dialog');
    dlg.id = 'PrrymQuickView';
    dlg.className = 'prrym prrym-qv';
    dlg.setAttribute('aria-label', 'Quick view');
    dlg.innerHTML = '<button type="button" class="prrym-qv__close" aria-label="Close quick view">&times;</button><div class="prrym-qv__body"></div>';
    document.body.appendChild(dlg);
    dlg.querySelector('.prrym-qv__close').addEventListener('click', function () { dlg.close(); });
    dlg.addEventListener('click', function (ev) { if (ev.target === dlg) dlg.close(); });
    dlg.addEventListener('close', function () { if (lastFocus) lastFocus.focus(); });
    return dlg;
  }
  document.addEventListener('click', function (e) {
    var btn = e.target.closest && e.target.closest('[data-prrym-qv]');
    if (!btn) return;
    var url = btn.getAttribute('data-prrym-qv');
    var dlg = getDialog();
    if (typeof dlg.showModal !== 'function' || !window.fetch) return;
    e.preventDefault();
    lastFocus = btn;
    var body = dlg.querySelector('.prrym-qv__body');
    body.innerHTML = '<p class="prrym-qv__loading" role="status">Loading product...</p>';
    dlg.showModal();
    fetch(url + (url.indexOf('?') > -1 ? '&' : '?') + 'section_id=prrym-quick-view')
      .then(function (res) { if (!res.ok) throw new Error('status'); return res.text(); })
      .then(function (html) {
        var doc = new DOMParser().parseFromString(html, 'text/html');
        var inner = doc.querySelector('.prrym-qv__inner');
        if (!inner) throw new Error('missing');
        body.innerHTML = '';
        body.appendChild(inner);
        ensureModelViewer(inner);
        var t = inner.querySelector('h2');
        if (t) { t.setAttribute('tabindex', '-1'); t.focus(); }
      })
      .catch(function () { window.location.href = url; });
  });

  /* Inquiry form validation */
  function fieldOf(input) { return input.closest('.prrym-field'); }
  function validateInput(input) {
    var field = fieldOf(input);
    if (!field) return true;
    var ok = input.checkValidity();
    field.classList.toggle('is-invalid', !ok);
    input.setAttribute('aria-invalid', ok ? 'false' : 'true');
    var err = field.querySelector('.prrym-field__error');
    if (err && !ok) {
      if (input.validity.valueMissing) err.textContent = 'This field is required.';
      else if (input.validity.typeMismatch) err.textContent = input.type === 'email' ? 'Please enter a valid email address.' : 'Please enter a valid value.';
      else if (input.validity.rangeUnderflow) err.textContent = input.type === 'date' ? 'Please choose today or a later date.' : 'Please enter ' + input.min + ' or more.';
      else if (input.validity.rangeOverflow) err.textContent = 'Please enter ' + input.max + ' or less.';
      else err.textContent = input.validationMessage;
    }
    return ok;
  }
  function initForms(root) {
    (root || document).querySelectorAll('form[data-prrym-form]').forEach(function (form) {
      if (form.dataset.prrymReady) return;
      form.dataset.prrymReady = 'true';
      form.setAttribute('novalidate', '');
      var inputs = form.querySelectorAll('input:not([type="hidden"]), select, textarea');
      inputs.forEach(function (input) {
        input.addEventListener('blur', function () { if (input.value !== '') validateInput(input); });
        input.addEventListener('input', function () { var f = fieldOf(input); if (f && f.classList.contains('is-invalid')) validateInput(input); });
      });
      var now = new Date();
      var iso = new Date(now.getTime() - now.getTimezoneOffset() * 60000).toISOString().slice(0, 10);
      form.querySelectorAll('input[type="date"]').forEach(function (d) { d.min = iso; });
      var qty = form.querySelector('[data-prrym-moq]');
      var note = form.querySelector('[data-prrym-moq-note]');
      if (qty && note) {
        var moq = parseInt(qty.getAttribute('data-prrym-moq'), 10) || 50;
        var update = function () { var v = parseInt(qty.value, 10); note.classList.toggle('is-shown', !isNaN(v) && v > 0 && v < moq); };
        qty.addEventListener('input', update); update();
      }
      var wrap = form.closest('[data-prrym-inquiry]');
      var mail = wrap && wrap.querySelector('[data-prrym-mailto]');
      var project = form.querySelector('[data-prrym-project]');
      if (mail && project) {
        var to = mail.getAttribute('data-prrym-mailto');
        var subjectBase = mail.getAttribute('data-prrym-subject') || 'Files for my quote request';
        var sync = function () { mail.setAttribute('href', 'mailto:' + to + '?subject=' + encodeURIComponent(subjectBase + (project.value ? ' - ' + project.value : ''))); };
        project.addEventListener('input', sync); sync();
      }
      form.addEventListener('submit', function (e) {
        var firstInvalid = null;
        inputs.forEach(function (input) { if (!validateInput(input) && !firstInvalid) firstInvalid = input; });
        if (firstInvalid) { e.preventDefault(); firstInvalid.focus(); return; }
        var btn = form.querySelector('button[type="submit"]');
        if (btn) { btn.setAttribute('aria-disabled', 'true'); btn.textContent = 'Sending...'; }
      });
    });
  }

  /* Pinned scroll sequences: the section stays in view (CSS sticky) while --seq runs 0 to 1 with scroll.
     Desktop only, never with reduced motion; anything outside the range falls back to a normal section. */
  var seqEls = [], seqTicking = false;
  function scrollRoot() {
    var pw = document.querySelector('.page-wrapper');
    if (pw) { var o = getComputedStyle(pw).overflowY; if ((o === 'auto' || o === 'scroll') && pw.scrollHeight > pw.clientHeight + 2) return pw; }
    return null;
  }
  function freeSticky(el) {
    var sc = scrollRoot(), p = el.parentElement;
    while (p && p !== document.body && p !== sc) {
      var cs = getComputedStyle(p);
      if (/(hidden|auto|scroll)/.test(cs.overflowX + ' ' + cs.overflowY)) p.style.overflow = 'clip';
      p = p.parentElement;
    }
  }
  function seqOn(el) {
    var min = parseInt(el.getAttribute('data-seq-min') || '990', 10);
    if (reduced || window.innerWidth < min) return false;
    if (el.querySelector('.is-fallback')) return false;
    if (el.hasAttribute('data-seq-webgl') && !window.WebGLRenderingContext) return false;
    return true;
  }
  function updateSeq() {
    seqTicking = false;
    var vh = window.innerHeight;
    seqEls.forEach(function (el) {
      var on = seqOn(el);
      if (on !== el.classList.contains('is-seq')) { el.classList.toggle('is-seq', on); if (on) freeSticky(el); }
      if (!on) { el.__seq = 0; el.style.setProperty('--seq', '0'); el.style.setProperty('--seq-e', '0'); return; }
      var r = el.getBoundingClientRect();
      var p = Math.min(Math.max(-r.top / Math.max(r.height - vh, 1), 0), 1);
      var e = Math.min(p / 0.55, 1); e = e * e * (3 - 2 * e);
      el.__seq = p;
      el.style.setProperty('--seq', p.toFixed(4));
      el.style.setProperty('--seq-e', e.toFixed(4));
      el.setAttribute('data-step', p < 0.08 ? '0' : p < 0.45 ? '1' : p < 0.76 ? '2' : '3');
    });
  }
  function initSeq(root) {
    (root || document).querySelectorAll('[data-prrym-seq]').forEach(function (el) {
      if (seqEls.indexOf(el) > -1) return;
      seqEls.push(el);
    });
    if (!seqEls.length) return;
    if (!initSeq.bound) {
      initSeq.bound = true;
      document.addEventListener('scroll', function () { if (!seqTicking) { seqTicking = true; requestAnimationFrame(updateSeq); } }, { passive: true, capture: true });
      window.addEventListener('resize', updateSeq, { passive: true });
    }
    updateSeq();
  }

  function init(root) { initSeq(root); initReveal(root); initTilt(root); initParallax(root); initForms(root); }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', function () { init(); });
  else init();
  document.addEventListener('shopify:section:load', function (e) { init(e.target); });
})();